import { FontWeight, ITheme } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { showText: boolean }, ITheme>(
  ({ colors }: ITheme) => ({
    root: {
      cursor: 'pointer',
      'user-select': 'none',
      '-webkit-user-select': 'none',
      padding: [8, 0, 4],
      width: '100%',
      backgroundColor: 'var(--x-bg-5)',
      borderRadius: '8px',
      marginBottom: 24,
    },
    header: {
      borderBottom: ({ showText }) => (showText ? '1px solid var(--x-bg-8)' : 'none'),
      marginBottom: ({ showText }) => (showText ? 12 : 0),
      paddingBottom: 8,
      fontSize: '12px',
      lineHeight: '20px',
      fontWeight: FontWeight.SemiBold,
      '& svg ': {
        verticalAlign: 'bottom',
        marginLeft: 4,
        width: 20,
        height: 20,
        '& path': {
          fill: colors.black,
        },
      },
    },
    icon: {
      '& > svg > path': {
        fill: colors.black,
      },
    },
  }),
  { name: 'Rephrased' },
);
export default useStyles;
